import React from "react";
import { motion } from "framer-motion";

const FadeRight = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 100 }} // Start off-screen to the right
      animate={{ opacity: 1, x: 0 }} // Fade in and slide to original position
      transition={{ duration: 2 }}
    >
      {children}
    </motion.div>
  );
};

export default FadeRight;
